module.exports = __webpack_public_path__ + "img/header.35ab8838.svg";